import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import {
    Button,
    Card,
    Container,
    Row,
    Col,
    Form,
    Alert,
} from "react-bootstrap";

import { Lists } from "./List";
// import { useActions } from "../../../hooks/useAction";
// import { useSelector } from "react-redux";
import { tableColumns } from "./Data.js";
import { SnackbarAlert } from "../../../components/SnackbarAlert";
import api from "../../../service/api";
import { pressEnterToSearch } from "../../../utils/utility.js";
const Course = () => {
    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState("");
    const [courses, setCourse] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    // const { getAllCourse } = useActions();
    const [notif, setNotif] = useState({
        notifMsg: "",
        open: false,
        severity: "success",
    });

    const getAllCourse = async (search) => {
        try {
            setLoading(true);
            const response = await api.get("tms/courses", {
                ...search,
            });
            setCourse(response);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setError(error?.response?.data?.message);
        }
    };

    const search = () => {
        getAllCourse({
            search: searchValue,
        });
    };

    const getCourseData = useCallback((search) => {
        getAllCourse(search);
    }, []); //  eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        getCourseData();
    }, []); //  eslint-disable-line react-hooks/exhaustive-deps

    // const { data, error, loading } = useSelector((state) => state.courses);

    return (
        <React.Fragment>
            <Helmet title="Configuration > Course" />
            <Container fluid className="p-0">
                <h1 className="h3 mb-3">Courses</h1>
                <Card>
                    <Card.Header>
                        {error && (
                            <Alert className="my-3" variant="danger">
                                <div className="alert-message">
                                    {error.message}
                                </div>
                            </Alert>
                        )}
                        <Row>
                            <Col md={6}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Control
                                            className="d-inline-block"
                                            type="text"
                                            value={searchValue}
                                            onChange={(e) =>
                                                setSearchValue(e.target.value)
                                            }
                                            onKeyDown={(e) => pressEnterToSearch(e, search)}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <Button
                                            variant="success"
                                            className="me-1 mb-1"
                                            onClick={search}
                                        >
                                            Search
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={6}>
                                <Button
                                    variant="primary"
                                    className="me-1 float-end"
                                    onClick={() => navigate("/tms/courses/add")}
                                >
                                    Add
                                </Button>
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body>
                        {loading && <div>Loading...</div>}
                        {courses && courses.data && !loading && (
                            <Lists
                                columns={tableColumns}
                                rawData={courses}
                                courseApi={getCourseData}
                            />
                        )}
                    </Card.Body>
                </Card>
            </Container>
            <SnackbarAlert notif={notif} setNotif={setNotif} />
        </React.Fragment>
    );
};

export default Course;
